import { Link } from "react-router-dom";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

/** Hesap sayfalarının başlığı: geri bağlantısı ve hafif başlık. */
export function AccountHeader({ title, backTo }) {
  return (
    <div className="flex items-center gap-3">
      {backTo ? (
        <Link
          to={backTo}
          aria-label="Geri"
          className="w-9 h-9 rounded-full flex items-center justify-center bg-terakkiBrandCloud text-terakkiPrimaryDark"
        >
          <ArrowBackIcon fontSize="small" />
        </Link>
      ) : null}
      <h1 className="text-2xl font-SemiBold text-terakkiPrimaryDark">{title}</h1>
    </div>
  );
}

/** Bölüm başlığı: küçük, soluk. */
export function SectionLabel({ children }) {
  return <div className="text-sm font-SemiBold text-terakkiNeutral tracking-wide px-1 pt-4 pb-1">{children}</div>;
}

/**
 * Yumuşak satır (mobil SoftRow): tam genişlik, ince alt çizgi, açık simge
 * yuvarlağı, hafif yazılar; bağlantı ya da düğme olabilir.
 */
export function SoftRow({ Icon, title, meta, to, onClick, danger }) {
  const body = (
    <>
      <span
        className={`w-10 h-10 rounded-full flex items-center justify-center shrink-0 ${
          danger ? "bg-terakkiError/10 text-terakkiError" : "bg-terakkiBrandCloud text-terakkiPrimaryDark"
        }`}
      >
        {Icon ? <Icon fontSize="small" aria-hidden /> : null}
      </span>
      <span className="min-w-0 flex-1 text-left">
        <span className={`block text-base font-SemiBold truncate ${danger ? "text-terakkiError" : "text-terakkiInk"}`}>
          {title}
        </span>
        {meta ? <span className="block text-sm text-terakkiNeutral truncate">{meta}</span> : null}
      </span>
      {to || onClick ? <ChevronRightIcon className="text-terakkiBorder" fontSize="small" aria-hidden /> : null}
    </>
  );
  const cls = "w-full flex items-center gap-3 px-4 py-3 border-b border-terakkiBorder last:border-b-0";
  if (to) {
    return (
      <Link to={to} className={`${cls} hover:bg-terakkiBrandCloud/60 dark:hover:bg-white/5 transition-colors`}>
        {body}
      </Link>
    );
  }
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={`${cls} hover:bg-terakkiBrandCloud/60 dark:hover:bg-white/5 transition-colors`}>
        {body}
      </button>
    );
  }
  return <div className={cls}>{body}</div>;
}

/** Satır grubu: tek ince kenarlı kap, kutu gölgesi yok. */
export function RowGroup({ children }) {
  return <div className="rounded-2xl border border-terakkiBorder bg-terakkiSurface overflow-hidden">{children}</div>;
}

/** Sayfanın altında sabit düğme bölgesi (mobil TabFooterButton). */
export function FixedFooter({ children }) {
  return (
    <div className="sticky bottom-0 mt-4 -mx-1 px-1 pt-3 pb-2 border-t border-terakkiBorder bg-terakkiSurfaceAlt/90 dark:bg-[#123B3D]/95 backdrop-blur">
      {children}
    </div>
  );
}
